@if (!isOpen() && isBobEnabled) {
    <!--
        CustomFloatingComponentComponent handles all drag, corner-snap, boundary
        clamping, and resize detection. We just project the bubble button as the
        floating content and listen to (dragReleased) to guard against the synthetic
        click that fires right after a CDK drag-release.

        The host is styled as position:fixed + inset:0 so the drag boundary spans
        the full viewport, letting the bubble reach all 4 corners.
    -->
    <app-custom-floating-component
        style="position: fixed; inset: 0; z-index: 50; pointer-events: none;"
        (dragReleased)="onDragReleased()">

        <ng-template #floatingUI>
            <button
                class="w-14 h-14 rounded-full bg-white shadow-xl hover:shadow-2xl hover:scale-105 transition-all duration-200 border-0 p-0 select-none pointer-events-auto"
                pTooltip="Ask Bob"
                tooltipPosition="left"
                (click)="onBubbleClick()"
                aria-label="Ask Bob">
                <img [src]="'images/bob_agent/bob.svg' | assetUrl" alt="Ask Bob" class="w-14 h-14 rounded-full" />
            </button>
        </ng-template>

    </app-custom-floating-component>
}
